module.exports = __webpack_public_path__ + "img/download_resume_mob.e9e5b2b1.svg";